<div class="report-page">
    <!-- Header Bar -->
    <div class="report-header">
        <div class="report-title">
            <i class="pi pi-chart-bar"></i>
            <span>Execution Report</span>
        </div>
        <div class="report-actions">
            <div class="search-box">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="viewModel.onGlobalFilter(dt, $event)" placeholder="Search..." />
            </div>
            <button class="action-btn" pTooltip="Download Excel" tooltipPosition="bottom"
                [disabled]="viewModel.executionGroups().length === 0" (click)="viewModel.exportXlsx(true)">
                <i class="pi pi-file-excel"></i>
            </button>
            <button class="action-btn" pTooltip="Download PDF" tooltipPosition="bottom"
                [disabled]="viewModel.executionGroups().length === 0" (click)="viewModel.exportPdf(true)">
                <i class="pi pi-file-pdf"></i>
            </button>
        </div>
    </div>

    <!-- Summary Strip -->
    <div class="summary-strip">
        <div class="summary-item">
            <span class="summary-num">{{ viewModel.summary().totalExecutions }}</span>
            <span class="summary-text">Executions</span>
        </div>
        <div class="summary-divider"></div>
        <div class="summary-item">
            <span class="summary-num">{{ viewModel.summary().totalScenarios }}</span>
            <span class="summary-text">Scenarios</span>
        </div>
        <div class="summary-divider"></div>
        <div class="summary-item">
            <span class="summary-num">{{ viewModel.summary().totalSteps }}</span>
            <span class="summary-text">Steps</span>
        </div>
        <div class="summary-divider"></div>
        <div class="summary-item summary-item--success">
            <span class="summary-num">{{ viewModel.summary().totalPassed }}</span>
            <span class="summary-text">Passed</span>
        </div>
        <div class="summary-divider"></div>
        <div class="summary-item summary-item--danger">
            <span class="summary-num">{{ viewModel.summary().totalFailed }}</span>
            <span class="summary-text">Failed</span>
        </div>
        <div class="summary-divider"></div>
        <div class="summary-item summary-item--warn">
            <span class="summary-num">{{ viewModel.summary().totalStopped }}</span>
            <span class="summary-text">Stopped</span>
        </div>
        <div class="summary-divider"></div>
        <div class="summary-item summary-item--info">
            <span class="summary-num">{{ viewModel.summary().passRate }}%</span>
            <span class="summary-text">Pass Rate</span>
        </div>
    </div>

    <!-- Filter Bar -->
    <div class="filter-bar">
        <div class="filter-bar-left">
            <i class="pi pi-filter filter-bar-icon"></i>

            <!-- Client -->
            <div class="filter-select">
                <p-select [options]="viewModel.clientOptions()" [ngModel]="viewModel.selectedClient()" [filter]="true"
                    placeholder="Client" optionLabel="label" optionValue="value"
                    [showClear]="!!viewModel.selectedClient() && viewModel.selectedClient() !== 'default' && !viewModel.isClientDropdownDisabled()"
                    [disabled]="viewModel.isClientDropdownDisabled()" [appendTo]="'body'"
                    (onChange)="viewModel.onClientChange($event.value)" (onClear)="viewModel.onClientChange(null)">
                </p-select>
            </div>

            <!-- Package -->
            <div class="filter-select">
                <p-select [options]="viewModel.packageOptions()" [ngModel]="viewModel.selectedPackage()" [filter]="true"
                    placeholder="Package" optionLabel="label" optionValue="value"
                    [showClear]="!!viewModel.selectedPackage()" [appendTo]="'body'"
                    (onChange)="viewModel.onPackageChange($event.value)" (onClear)="viewModel.onPackageChange(null)">
                </p-select>
            </div>

            <!-- Test Type (multiselect) -->
            <div class="filter-select">
                <p-multiSelect [options]="viewModel.testTypeOptions()" [ngModel]="viewModel.selectedTestType()"
                    (onChange)="viewModel.onTestTypeChange($event.value)" (onClear)="viewModel.onTestTypeChange([])"
                    optionLabel="label" optionValue="value" placeholder="Test Type" [filter]="true"
                    [showClear]="viewModel.selectedTestType().length > 0" display="chip" [maxSelectedLabels]="1"
                    [appendTo]="'body'" styleClass="w-full">
                </p-multiSelect>
            </div>

            <!-- Functional Area (multiselect) -->
            <div class="filter-select">
                <p-multiSelect [options]="viewModel.functionalAreaOptions()"
                    [ngModel]="viewModel.selectedFunctionalArea()"
                    (onChange)="viewModel.onFunctionalAreaChange($event.value)"
                    (onClear)="viewModel.onFunctionalAreaChange([])" optionLabel="label" optionValue="value"
                    [placeholder]="viewModel.selectedTestType().length > 0 ? 'Functional Area' : 'Select Type first'"
                    [disabled]="viewModel.selectedTestType().length === 0"
                    [showClear]="viewModel.selectedFunctionalArea().length > 0" [filter]="true" display="chip"
                    [maxSelectedLabels]="1" [appendTo]="'body'" styleClass="w-full">
                </p-multiSelect>
            </div>

            <!-- Scenario -->
            <div class="filter-select">
                <p-select [options]="viewModel.scenarioOptions()" [ngModel]="viewModel.selectedScenario()"
                    [filter]="true"
                    [placeholder]="viewModel.selectedFunctionalArea().length > 0 ? 'Scenario' : 'Select Area first'"
                    optionLabel="label" optionValue="value" [showClear]="!!viewModel.selectedScenario()"
                    [disabled]="viewModel.selectedFunctionalArea().length === 0" [appendTo]="'body'"
                    (onChange)="viewModel.onScenarioChange($event.value)" (onClear)="viewModel.onScenarioChange(null)">
                </p-select>
            </div>

            <!-- Date Range -->
            <div class="filter-select filter-select--date">
                <p-datepicker [ngModel]="viewModel.dateRange()" (ngModelChange)="viewModel.onDateRangeChange($event)"
                    selectionMode="range" placeholder="Date Range" dateFormat="dd/mm/yy" [maxDate]="viewModel.maxDate"
                    [showIcon]="true" [showClear]="false" [appendTo]="'body'" styleClass="w-full">
                </p-datepicker>
            </div>
        </div>

        <div class="filter-bar-right">
            <!-- Status Toggle Buttons -->
            <div class="status-toggles">
                <button class="status-btn" [class.active]="!viewModel.selectedStatus()"
                    (click)="viewModel.onStatusChange(null)">All</button>
                <button class="status-btn status-btn--passed" [class.active]="viewModel.selectedStatus() === 'Passed'"
                    (click)="viewModel.onStatusChange('Passed')">Passed</button>
                <button class="status-btn status-btn--failed" [class.active]="viewModel.selectedStatus() === 'Failed'"
                    (click)="viewModel.onStatusChange('Failed')">Failed</button>
                <button class="status-btn status-btn--stopped" [class.active]="viewModel.selectedStatus() === 'Stopped'"
                    (click)="viewModel.onStatusChange('Stopped')">Stopped</button>
            </div>

            @if (viewModel.hasActiveFilters()) {
            <button class="clear-btn" (click)="viewModel.clearFilters()">
                <i class="pi pi-times"></i> Clear
            </button>
            }
        </div>
    </div>


    <!-- Data Table (flat — no inline step expansion) -->
    <p-table #dt [value]="viewModel.executionGroups()" [rows]="10" [paginator]="true"
        [globalFilterFields]="['searchText']" [tableStyle]="{ 'min-width': '1100px' }" [rowHover]="true"
        dataKey="executionId" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} executions"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 20, 30]" [scrollable]="true"
        scrollHeight="flex" styleClass="report-table report-table-compact">

        <ng-template #header>
            <tr>
                <th style="width: 3%"></th>
                <th pSortableColumn="packageName">
                    Package <p-sortIcon field="packageName" />
                </th>
                <th pSortableColumn="testTypeName">
                    Test Type <p-sortIcon field="testTypeName" />
                </th>
                <th>Functional Area</th>
                <th>Scenario</th>
                <th style="text-align: center">Steps</th>
                <th style="text-align: center">Passed</th>
                <th style="text-align: center">Failed</th>
                <th style="text-align: center">Stopped</th>
                <th>Progress</th>
                <th>Status</th>
                <th pSortableColumn="executedOn">
                    Executed On <p-sortIcon field="executedOn" />
                </th>
                <th pSortableColumn="executedBy">
                    Executed By <p-sortIcon field="executedBy" />
                </th>
                <th>Tenant</th>
            </tr>
        </ng-template>

        <ng-template #body let-group>
            <!-- Main execution row -->
            <tr [class.row-multi]="group.scenarioCount > 1"
                [class.row-status-passed]="group.overallStatus === 'Passed'"
                [class.row-status-failed]="group.overallStatus === 'Failed'"
                [class.row-status-stopped]="group.overallStatus === 'Stopped'">
                <td>
                    @if (group.scenarioCount > 1) {
                    <p-button [icon]="group.isExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" [rounded]="true"
                        [text]="true" severity="secondary" (click)="viewModel.toggleExpand(group)"></p-button>
                    } @else {
                    <p-button icon="pi pi-eye" [rounded]="true" [text]="true" severity="secondary"
                        pTooltip="View steps" tooltipPosition="top"
                        (click)="viewModel.openDrawer(group.scenarios[0])"></p-button>
                    }
                </td>
                <td>{{ group.packageName }}</td>
                <td>{{ group.testTypeName }}</td>
                <td>{{ group.functionalAreaName }}</td>
                <td>
                    @if (group.scenarioCount > 1) {
                    <span class="scenario-count">{{ group.scenarioCount }} Scenarios</span>
                    } @else {
                    {{ group.scenarios[0]?.scenario?.scenarioName || '-' }}
                    }
                </td>
                <td class="text-center font-semibold">{{ group.totalSteps }}</td>
                <td class="text-center font-semibold text-passed">{{ group.totalPassed }}</td>
                <td class="text-center font-semibold" [class.text-failed]="group.totalFailed > 0"
                    [class.text-muted]="group.totalFailed === 0">{{ group.totalFailed }}</td>
                <td class="text-center font-semibold" [class.text-stopped]="group.totalStopped > 0"
                    [class.text-muted]="group.totalStopped === 0">{{ group.totalStopped }}</td>
                <td>
                    <div class="progress-container">
                        <div class="progress-bar-custom">
                            <div class="progress-fill-passed"
                                [style.width.%]="group.totalSteps > 0 ? (group.totalPassed / group.totalSteps * 100) : 0">
                            </div>
                            <div class="progress-fill-failed"
                                [style.width.%]="group.totalSteps > 0 ? (group.totalFailed / group.totalSteps * 100) : 0">
                            </div>
                        </div>
                        <span class="progress-label">{{ group.passRate }}%</span>
                    </div>
                </td>
                <td>
                    <p-tag [value]="group.overallStatus" [severity]="viewModel.getStatusSeverity(group.overallStatus)">
                    </p-tag>
                </td>
                <td>{{ viewModel.formatDate(group.executedOn) }}</td>
                <td>{{ group.executedBy || '-' }}</td>
                <td>{{ group.tenantName || '-' }}</td>
            </tr>

            <!-- Expanded child scenario rows (multi-scenario) — flat, no inline steps -->
            @if (group.isExpanded && group.scenarioCount > 1) {
            @for (scenario of group.scenarios; track scenario.id) {
            <tr class="row-expanded-child"
                [class.row-status-passed]="viewModel.getRowStatus(scenario) === 'Passed'"
                [class.row-status-failed]="viewModel.getRowStatus(scenario) === 'Failed'"
                [class.row-status-stopped]="viewModel.getRowStatus(scenario) === 'Stopped'"
                (click)="viewModel.openDrawer(scenario)" style="cursor: pointer;">
                <td>
                    <p-button icon="pi pi-eye" [rounded]="true" [text]="true" severity="secondary"
                        [style]="{ width: '1.75rem', height: '1.75rem' }"
                        pTooltip="View steps" tooltipPosition="top"
                        (click)="viewModel.openDrawer(scenario); $event.stopPropagation()"></p-button>
                </td>
                <td></td>
                <td></td>
                <td>{{ scenario.functionalArea?.name || '-' }}</td>
                <td>{{ scenario.scenario?.scenarioName || '-' }}</td>
                <td class="text-center">{{ scenario.numberOfSteps }}</td>
                <td class="text-center text-passed">{{ scenario.passed }}</td>
                <td class="text-center" [class.text-failed]="(scenario.failed || 0) > 0"
                    [class.text-muted]="(scenario.failed || 0) === 0">{{ scenario.failed || 0 }}</td>
                <td class="text-center"
                    [class.text-stopped]="viewModel.calcStopped(scenario) > 0"
                    [class.text-muted]="viewModel.calcStopped(scenario) === 0">
                    {{ viewModel.calcStopped(scenario) }}</td>
                <td>
                    <div class="progress-container">
                        <div class="progress-bar-custom">
                            <div class="progress-fill-passed"
                                [style.width.%]="scenario.numberOfSteps ? ((scenario.passed || 0) / scenario.numberOfSteps * 100) : 0">
                            </div>
                            <div class="progress-fill-failed"
                                [style.width.%]="scenario.numberOfSteps ? ((scenario.failed || 0) / scenario.numberOfSteps * 100) : 0">
                            </div>
                        </div>
                    </div>
                </td>
                <td>
                    <p-tag [value]="viewModel.getRowStatus(scenario)"
                        [severity]="viewModel.getStatusSeverity(viewModel.getRowStatus(scenario))">
                    </p-tag>
                </td>
                <td class="text-muted">{{ viewModel.formatDate(scenario.executedOn) }}</td>
                <td class="text-muted">{{ scenario.executedByUser ? (scenario.executedByUser.firstName || '') + ' ' + (scenario.executedByUser.lastName || '') : (scenario.executedBy || '-') }}</td>
                <td class="text-muted">{{ scenario.clientTenant?.tenantName || '-' }}</td>
            </tr>
            }
            }
        </ng-template>

        <ng-template #emptymessage>
            <tr>
                <td colspan="14" class="noData">No execution data found.</td>
            </tr>
        </ng-template>
    </p-table>

    <p-toast></p-toast>

    <!-- Step Details Drawer (replaces all inline step expansion) -->
    <p-drawer [(visible)]="viewModel.drawerVisible" position="right" [style]="{ width: '580px' }"
        [modal]="true" [dismissible]="true" [blockScroll]="true"
        styleClass="step-drawer" (onHide)="viewModel.closeDrawer()">
        <ng-template #header>
            <div class="drawer-header">
                <div class="drawer-title">
                    <i class="pi pi-list-check"></i>
                    <span>Step Details</span>
                </div>
                @if (viewModel.drawerScenario) {
                <div class="drawer-subtitle">
                    {{ viewModel.drawerScenario.scenario?.scenarioName || 'Scenario' }}
                </div>
                }
            </div>
        </ng-template>
        <ng-template #content>
            @if (viewModel.drawerScenario) {
            <!-- Scenario summary card -->
            <div class="drawer-summary">
                <div class="drawer-summary-row">
                    <span class="drawer-summary-label">Functional Area</span>
                    <span>{{ viewModel.drawerScenario.functionalArea?.name || '-' }}</span>
                </div>
                <div class="drawer-summary-row">
                    <span class="drawer-summary-label">Package</span>
                    <span>{{ viewModel.drawerScenario.package?.packageName || '-' }}</span>
                </div>
                <div class="drawer-summary-stats">
                    <div class="drawer-stat drawer-stat--total">
                        <span class="drawer-stat-num">{{ viewModel.drawerScenario.numberOfSteps || 0 }}</span>
                        <span class="drawer-stat-label">Steps</span>
                    </div>
                    <div class="drawer-stat drawer-stat--passed">
                        <span class="drawer-stat-num">{{ viewModel.drawerScenario.passed || 0 }}</span>
                        <span class="drawer-stat-label">Passed</span>
                    </div>
                    <div class="drawer-stat drawer-stat--failed">
                        <span class="drawer-stat-num">{{ viewModel.drawerScenario.failed || 0 }}</span>
                        <span class="drawer-stat-label">Failed</span>
                    </div>
                    <div class="drawer-stat drawer-stat--stopped">
                        <span class="drawer-stat-num">{{ viewModel.calcStopped(viewModel.drawerScenario) }}</span>
                        <span class="drawer-stat-label">Stopped</span>
                    </div>
                </div>
            </div>

            <!-- Failures only toggle -->
            @if (viewModel.drawerSteps().length > 0) {
            <div class="drawer-toolbar">
                <button class="drawer-filter-btn" [class.active]="viewModel.drawerShowFailuresOnly()"
                    (click)="viewModel.toggleDrawerFailuresOnly()">
                    <i class="pi pi-exclamation-circle"></i>
                    Failures Only
                </button>
                <span class="drawer-step-count">
                    {{ viewModel.drawerFilteredSteps().length }} of {{ viewModel.drawerSteps().length }} steps
                </span>
            </div>
            }

            <!-- Loading -->
            @if (viewModel.drawerScenario.stepsLoading) {
            <div class="drawer-loading">
                <p-progressSpinner [style]="{ width: '28px', height: '28px' }" strokeWidth="4"></p-progressSpinner>
                <span>Loading steps...</span>
            </div>
            }

            <!-- Step cards -->
            @if (viewModel.drawerFilteredSteps().length > 0) {
            <div class="drawer-steps">
                @for (step of viewModel.drawerFilteredSteps(); track step.id; let i = $index) {
                <div class="drawer-step-card"
                    [class.drawer-step-card--passed]="step.passed === true"
                    [class.drawer-step-card--failed]="step.passed === false"
                    [class.drawer-step-card--stopped]="step.status === 'Stopped'"
                    (click)="step.status !== 'Stopped' ? viewModel.toggleStepLog(step.id) : null">
                    <!-- Step header -->
                    <div class="drawer-step-header">
                        <span class="step-number"
                            [class.step-number--passed]="step.passed === true"
                            [class.step-number--failed]="step.passed === false">
                            {{ step.stepOrder || (i + 1) }}
                        </span>
                        <div class="drawer-step-desc">
                            <span>{{ step.stepDescription }}</span>
                            @if (step.action) {
                            <span class="step-action-badge">{{ step.action }}</span>
                            }
                        </div>
                        <div class="drawer-step-meta">
                            <span class="text-muted" style="font-size: 0.7rem;">{{ viewModel.formatDuration(step.duration) }}</span>
                            <p-tag [value]="step.status"
                                [severity]="step.passed === true ? 'success' : step.passed === false ? 'danger' : step.status === 'Stopped' ? 'warn' : 'info'"
                                [style]="{ fontSize: '0.65rem' }">
                            </p-tag>
                            @if (step.screenshotUrl) {
                            <img [src]="viewModel.getScreenshotFullUrl(step.screenshotUrl)" alt="screenshot"
                                class="step-screenshot-thumb"
                                (click)="viewModel.viewScreenshot(step.screenshotUrl); $event.stopPropagation()"
                                pTooltip="Click to enlarge" tooltipPosition="top" />
                            }
                            @if (step.status !== 'Stopped') {
                            <i class="pi step-row-chevron"
                                [class.pi-chevron-down]="viewModel.isStepLogExpanded(step.id)"
                                [class.pi-chevron-right]="!viewModel.isStepLogExpanded(step.id)"></i>
                            }
                        </div>
                    </div>

                    <!-- Expanded step detail (error + log + screenshot side-by-side) -->
                    @if (step.status !== 'Stopped' && viewModel.isStepLogExpanded(step.id)) {
                    <div class="drawer-step-detail">
                        @if (step.error) {
                        <div class="step-detail-card step-detail-card--error">
                            <div class="step-detail-card-header">
                                <i class="pi pi-exclamation-triangle"></i> Error
                            </div>
                            <div class="step-detail-card-body">
                                <pre class="step-error-text">{{ step.error }}</pre>
                            </div>
                        </div>
                        }
                        <!-- Log details + screenshot in same row -->
                        <div class="step-detail-row" [class.step-detail-row--has-screenshot]="!!step.screenshotUrl">
                            @if (step.logText) {
                            @if (viewModel.parseLogText(step.logText); as logData) {
                            <div class="step-detail-card step-detail-card--log">
                                <div class="step-detail-card-header">
                                    <i class="pi pi-list"></i> Log Details
                                </div>
                                <div class="step-detail-card-body">
                                    <div class="step-log-row">
                                        <span class="step-log-label">Action:</span>
                                        <span>{{ logData.action || '-' }}</span>
                                    </div>
                                    <div class="step-log-row">
                                        <span class="step-log-label">Description:</span>
                                        <span>{{ logData.description || step.stepDescription }}</span>
                                    </div>
                                    @if (logData.duration != null) {
                                    <div class="step-log-row">
                                        <span class="step-log-label">Duration:</span>
                                        <span>{{ viewModel.formatDuration(logData.duration) }}</span>
                                    </div>
                                    }
                                    @if (logData.sessionId) {
                                    <div class="step-log-row">
                                        <span class="step-log-label">Session:</span>
                                        <span class="text-muted">{{ logData.sessionId }}</span>
                                    </div>
                                    }
                                    <div class="step-log-row">
                                        <span class="step-log-label">Status:</span>
                                        <p-tag [value]="step.status"
                                            [severity]="step.passed === true ? 'success' : step.passed === false ? 'danger' : step.status === 'Stopped' ? 'warn' : 'info'"
                                            [style]="{ fontSize: '0.7rem' }">
                                        </p-tag>
                                    </div>
                                    @if (logData.result?.result?.assertion; as assertion) {
                                    <div class="step-assertion-section">
                                        <div class="step-log-label" style="margin-bottom: 0.375rem;">Validation Result</div>
                                        <div class="step-assertion-grid">
                                            <div class="step-log-row">
                                                <span class="step-log-label">Type:</span>
                                                <span>{{ assertion.type }}</span>
                                            </div>
                                            @if (assertion.column) {
                                            <div class="step-log-row">
                                                <span class="step-log-label">Column:</span>
                                                <span>{{ assertion.column }}</span>
                                            </div>
                                            }
                                            @if (assertion.expected) {
                                            <div class="step-log-row">
                                                <span class="step-log-label">Expected:</span>
                                                <span>{{ assertion.expected }}</span>
                                            </div>
                                            }
                                            <div class="step-log-row">
                                                <span class="step-log-label">Status:</span>
                                                <p-tag [value]="assertion.passed ? 'Passed' : 'Failed'"
                                                    [severity]="assertion.passed ? 'success' : 'danger'"
                                                    [style]="{ fontSize: '0.65rem' }"></p-tag>
                                            </div>
                                            @if (assertion.totalValidated != null) {
                                            <div class="step-log-row">
                                                <span class="step-log-label">Validated:</span>
                                                <span>{{ assertion.totalValidated }}</span>
                                            </div>
                                            }
                                            @if (assertion.matchPercentage) {
                                            <div class="step-log-row">
                                                <span class="step-log-label">Match %:</span>
                                                <span>{{ assertion.matchPercentage }}</span>
                                            </div>
                                            }
                                        </div>
                                        @if (assertion.message) {
                                        <div class="step-assertion-message">{{ assertion.message }}</div>
                                        }
                                        @if (assertion.mismatchDetails?.length > 0) {
                                        <div class="step-mismatch-section">
                                            <div class="step-log-label" style="margin-bottom: 0.25rem;">Mismatch Details</div>
                                            @for (m of assertion.mismatchDetails; track m.row) {
                                            <div class="step-mismatch-row">
                                                <span class="step-mismatch-label">Row {{ m.row }}:</span>
                                                Expected "<strong>{{ m.expected }}</strong>", Found "<strong>{{ m.actual }}</strong>"
                                            </div>
                                            }
                                        </div>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>
                            }
                            }
                            @if (step.screenshotUrl) {
                            <div class="step-detail-card step-detail-card--screenshot">
                                <div class="step-detail-card-header">
                                    <i class="pi pi-image"></i> Screenshot
                                </div>
                                <div class="step-detail-card-body">
                                    <img [src]="viewModel.getScreenshotFullUrl(step.screenshotUrl)"
                                        alt="Step screenshot" class="step-screenshot-preview"
                                        (click)="viewModel.viewScreenshot(step.screenshotUrl); $event.stopPropagation()" />
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    }
                </div>
                }
            </div>
            }

            @if (!viewModel.drawerScenario.stepsLoading && viewModel.drawerSteps().length === 0) {
            <div class="drawer-empty">
                <i class="pi pi-inbox"></i>
                <span>No step details available for this scenario.</span>
            </div>
            }
            }
        </ng-template>
    </p-drawer>

    <p-confirmdialog [style]="{ width: '450px' }" />

    <!-- Screenshot Modal -->
    <p-dialog header="Screenshot" [(visible)]="viewModel.displayScreenshotDialog" [modal]="true"
        [dismissableMask]="true" [blockScroll]="true" [style]="{ width: '80vw', maxWidth: '1200px' }"
        [appendTo]="'body'">
        <ng-template #content>
            <div class="screenshot-modal-container">
                <img [src]="viewModel.selectedScreenshot()" alt="Step Screenshot" class="screenshot-modal-image" />
            </div>
        </ng-template>
    </p-dialog>
</div>
